import React , {useState , useEffect , useMemo} from 'react'
import Modal from 'react-bootstrap/Modal';
import { Typography, TextField , Paper , IconButton, InputAdornment , Checkbox , Box , Button , CircularProgress} from '@mui/material';
import { Col, Row } from 'react-bootstrap';
import SearchIcon from "@mui/icons-material/Search";
import ApiService from '../../functions/apiService';
import moment from 'moment';
import MyTable from '../../components/Schedule/MyTable';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { DataGrid } from '@mui/x-data-grid';
import { toast } from 'react-toastify';

const checkButtonStyle = {
    color: "#FFF",
    minWidth: "0",
    paddingRight: ".02rem",
    background: '#E62719',
    padding: '8px',
    ":hover": { color: "#fff", background: "#ff0000" },
    ":disabled": { color: "#fff", background: '#D0D5DD' }
  };

export const SwapModal = ({setOpen , selectedRow , loadData , backFunction}) => {
    const [loading, setLoading] = useState(false);
    const [rows , setRows] = useState([]);
    const [show , setShow] = useState(false);
    const [search , setSearch] = useState('');
    const [selectedData, setSelectedData] = useState([]);
    const [selectedRows, setSelectedRows] = useState(null);
    const [error , setError] = useState('');
		const [shifts , setShifts] = useState([]);

    let handleClose2 = () =>{
        setShow(false)
    }

		const shiftDetais = () =>{
			ApiService.get('/shiftTypes').then(({ data }) => {
				setShifts(data?.data || [])
			}).catch(() => {
				toast.error("Error")
			})
		}

		useEffect(()=>{
			shiftDetais()
		}, [])

    const columns = [
        {
          field: 'fullname',
          headerName: 'Name',
          width: 220,
          sortable: false,
          renderCell: (params) => (<Typography key={1} fontWeight={700} fontSize={16}>
            {params?.row?.employee?.employee_assignment?.EA_Rank} {params?.row?.employee?.fullName}
          </Typography>)
        },
        {   
            field: 'Shift_Date',
            headerName: 'Shift_Date',
            width: 160,
            renderCell: (params) => (<Typography key={1}  fontSize={14}>
                {moment(params?.row?.Shift_Date).format('MM/DD/YYYY')}
            </Typography>)
        },
				{   
            field: 'ShiftCode',
            headerName: 'Shift',
            width: 230,
            renderCell: (params) => {
							const shiftDetailData = shifts.find((shift) => shift.ShiftCode == params?.row?.over_time_shift?.Shift_Code)
							return(
							<Typography key={1} fontSize={14}>
								{shiftDetailData?.Shift 
									|| (`${params.row.over_time_shift.Start_Time} - ${params.row.over_time_shift.End_Time} `) 
									|| ''} 
								({moment(params?.row.Shift_Date).format('dddd')})
							</Typography>
						)
						}
        },
        {
            field: 'Assign',
            headerName: 'Action',
            width: 100,
            sortable: false,
            renderCell: (params) => {
                return (
                    <>
                    {
                        <Button
                            onClick={() => { 
                                setSelectedData(params.row)
                                setShow(true)
                            }}
                            sx={checkButtonStyle}
                            >Request</Button>
                    }
                    </>
                )
            }
        }
    ]

    let loadSwapEmployee = () => {
			setLoading(true)
        const date = {
            "Shift_Date" : selectedRow?.Overtime?.Shift_Date,
            "ShiftNumber" : selectedRow?.Overtime?.ShiftNumber,
            "ShiftCode": selectedRow?.Overtime?.ShiftCode
        }
        ApiService.post('/ot-swap-list' , date)
          .then((data) => {
            setLoading(false)
            setRows(data?.data)
          }).catch((data) => {
            setLoading(false)
            setError(data.data)
            // toast.error(data.data)
        })
    }

    useEffect(()=>{
        if(selectedRow){
            loadSwapEmployee()
        }
    }, [selectedRow])

    let SwapEmployee = () => {
        setLoading(true)
        const data = {
            "Shift_Date_Swap" : selectedData?.Shift_Date,
            "Shift_Number_Swap": selectedData?.Shift_Number,
            "Emp_Swap": selectedData?.Emp_Code,
            "Shift_Date_Self": selectedRow?.Overtime?.Shift_Date,
            "Shift_Number_Self": selectedRow?.Overtime?.ShiftNumber
        }
        ApiService.post('/ot-swap-apply' , data)
          .then((data) => {
            toast.success('Swap Request send successfully')
            loadData()
            setOpen(false)
          }).catch((data) => {
            toast.error(data.data)
            loadData()
            setOpen(false)
        })
    }

    const filteredData = useMemo(() => {
        return rows.filter((item) => {
        //   const rank = item?.employee?.employee_assignment?.EA_Rank?.toLowerCase() || "";
          const fullName = item?.employee?.fullName?.toLowerCase() || "";
          const combinedName = `${fullName}`;
      
          return combinedName.includes(search.toLowerCase());
        });
    }, [search, rows]);


    return (
        <Paper className='p-4'>
            {!loading &&
                <>
                    <Row className='px-3'>
                        <TextField
                            variant="outlined"
                            placeholder="Search by Name"
                            className="mt-0 w-100"
                            color='secondary'
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
														style={{marginBottom:'25px'}}
                            InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                <IconButton>
                                    <SearchIcon />
                                </IconButton>
                                </InputAdornment>
                            ),
                            sx: {
                                height: '48px',
                                fontSize: '14px'
                            },
                            }}
                        />
                    </Row>
                    {filteredData?.length > 0 ?
                        <div className='border border-1 rounded-2'>
                            <div style={{maxHeight:'45vh' , overflow:'scroll' , scrollbarWidth:'none'}}>
                                <DataGrid
                                    rows={filteredData}
                                    columns={columns}
                                    hideFooter={true}
                                    showHeader={false}
                                    // selectionModel={selectedRows ? [selectedRows] : []} 
                                    // onRowSelectionModelChange={(newSelection) => {
                                    //     if (newSelection.length > 0) {
                                    //         const selectedRowData = filteredData.find((row) => row.id === newSelection[0]);
                                    //         if (selectedRowData) {
                                    //             setSelectedData({
                                    //                 Shift_Date: selectedRowData.Shift_Date,
                                    //                 Shift_Number: selectedRowData.Shift_Number,
                                    //                 Emp_Code: selectedRowData.Emp_Code,
                                    //             });
                                    //         }
                                    //         setSelectedRows(newSelection[0]);
                                    //     } else {
                                    //         setSelectedRows([]);
                                    //         setSelectedData([]);
                                    //     }
                                    // }}
                                />
                            </div>
                        </div>
                        :
                        <div>
                            {error ? (
                                <Typography fontWeight={700} fontSize={16} className='d-flex justify-content-center mt-2' sx={{color:'#ff0000'}}>{error}</Typography>
                            ) : (
                                <Typography fontWeight={700} fontSize={16} className='w-100 d-flex justify-content-center mt-2'>No results found</Typography>
                            )}
                        </div>
                    }

							<Modal show={show} onHide={handleClose2} 
									style={{
											backgroundColor: 'rgba(0, 0, 0, 0.5)'
									}}>
									<Modal.Header closeButton>
									<Modal.Title>Confirm swapping?</Modal.Title>
									</Modal.Header>
									<Modal.Body>
											<Row>
													<p style={{color:'#555555'}}>Are you sure to swap your shift to :   
															<span style={{color:'#000000' , fontWeight:'550' , marginLeft: '5px'}}>
																	{selectedData?.employee?.fullName}
															</span>
													</p>
											</Row>
											<Row>
													<Col md='auto'>
													<ButtonTheme type='submit' variant="filled" color='#f5f5f5' className='mt-1' onClick = {handleClose2}>
															Cancel
													</ButtonTheme>
													</Col>
													<Col md='auto'>
													<ButtonTheme type='submit' variant="filled" color='primary' className='mt-1' onClick={SwapEmployee}>
															Yes
													</ButtonTheme>
													</Col>
											</Row>
									</Modal.Body>
							</Modal>
					</>
					}
        </Paper>
    )
}

export const SwapVacationModal = ({setOpen , loadData , backFunction , selectedRow}) => {
    const [loading, setLoading] = useState(false);
    const [rows , setRows] = useState([]);
    const [show , setShow] = useState(false);
    const [error , setError] = useState('')
    const [selectedData , setSelectedData] = useState([]);
		const [shifts , setShifts] = useState([]);

    let handleClose2 = () =>{
        setShow(false)
    }

		const shiftDetais = () =>{
			ApiService.get('/shiftTypes').then(({ data }) => {
				setShifts(data?.data || [])
			}).catch(() => {
				toast.error("Error")
			})
		}

		useEffect(()=>{
			shiftDetais()
		}, [])

    const columns = [
        {   
            field: 'Shift_Date',
            headerName: 'Shift_Date',
            width: 140,
            renderCell: (params) => (<Typography key={1}  fontSize={14}>
                {moment(params?.row?.Shift_Date).format('MM/DD/YYYY')}
            </Typography>)
        },
        {   
            field: 'ShiftCode',
            headerName: 'Shift',
            width: 180,
						renderCell: (params) => {
							const shiftDetailData = shifts.find((shift) => shift.ShiftCode == params?.row?.Shift_Code)
							return(
							<Typography key={1}  fontSize={14}>
									{shiftDetailData?.Shift} ({moment(params?.row.Shift_Date).format('dddd')})
							</Typography>
						)
						}
        },
        {
            field: 'Assign',
            headerName: 'Action',
            width: 100,
            sortable: false,
            renderCell: (params) => {
                return (
                    <>
                    {
                        <Button
                            onClick={() => { 
                                setShow(true)
                                setSelectedData(params.row)

                            }}
                            sx={checkButtonStyle}
                            >Request</Button>
                    }
                    </>
                )
            }
        }
    ]

    let loadSwapEmployee = () => {
        setLoading(true)
        ApiService.post('/ot-vac-my-list')
          .then((data) => {
            const updatedData = data?.data?.map((item , index) => ({
                ...item ,
                id : index + 1
            }))
            setLoading(false)
            setRows(updatedData)
          }).catch((data) => {
            setLoading(false)
            setError(data.data)
            // toast.error(data.data)
        })
    }

    useEffect(()=>{
        loadSwapEmployee()
    }, [])

    let SwapEmployee = () => {
        setLoading(true)
        const data = {
            "Shift_Date" : selectedRow?.Shift_Date,
            "Shift_Number": selectedRow?.Shift_Number,
            "Shift_Code": selectedRow?.Shift_Code,
            "Orig_Emp_Code": selectedRow?.Orig_Emp_Code,
            "My_Shift_Code" :  selectedData?.Shift_Code, 
            "My_Shift_Date" : selectedData?.Shift_Date
        }
        ApiService.post('/ot-vac-apply' , data)
          .then((data) => {
            toast.success('Swap Request send successfully')
            loadData()
            setOpen(false)
            setLoading(false)
          }).catch((data) => {
            toast.error(data.data.message)
            loadData()
            setOpen(false)
        })
    }


    return (
        <Paper className='p-4'>
            {!loading &&
                <>
                    <Row>
                        <Col md={11}>
                        <Typography fontWeight={700} fontSize={21} className="mb-3">My Shifts</Typography>
                        </Col>
                        <Col md={1}>
                        <img src='/images/close-icon.svg' onClick={backFunction} style={{ cursor: 'pointer', height: 25 }} />
                        </Col>
                    </Row>
                    {rows?.length > 0 ?
                        <div className='border border-1 rounded-2'>
                            <div style={{maxHeight:'45vh' , overflow:'scroll' , scrollbarWidth:'none'}}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    hideFooter={true}
                                    showHeader={false}
                                />
                            </div>
                        </div>
                        :
                        <div>
                            {error ? (
                                <Typography fontWeight={700} fontSize={16} className='d-flex justify-content-center mt-2' sx={{color:'#ff0000'}}>{error}</Typography>
                            ) : (
                                <Typography fontWeight={700} fontSize={16} className='w-100 d-flex justify-content-center mt-2'>No results found</Typography>
                            )}
                        </div>
                    }

                    <Modal show={show} onHide={handleClose2} 
                        style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.5)'
                        }}>
                        <Modal.Header closeButton>
                        <Modal.Title>Confirm swapping?</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <p style={{color:'#555555'}}>Are you sure to swap your shift to :   
                                    <span style={{color:'#000000' , fontWeight:'550' , marginLeft: '5px'}}>
                                        {selectedRow?.orig_emp?.employee_assignment?.EA_Rank + ' ' + selectedRow?.orig_emp?.fullName}
                                    </span>
                                </p>
                            </Row>
                            <Row>
                                <Col md='auto'>
                                <ButtonTheme type='submit' variant="filled" color='#f5f5f5' className='mt-1' onClick = {handleClose2}>
                                    Cancel
                                </ButtonTheme>
                                </Col>
                                <Col md='auto'>
                                <ButtonTheme type='submit' variant="filled" color='primary' className='mt-1' onClick={SwapEmployee}>
                                    Yes
                                </ButtonTheme>
                                </Col>
                            </Row>
                        </Modal.Body>
                    </Modal>
                </>
            }
        </Paper>
    )
}